import React, { createContext, useContext, useMemo } from 'react'

import { node, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

// The i18next singleton stays on lng 'en': non-EN rails bundles are only *registered* (client-side
// via loadLocaleBundle, at SSR via registerAllLocales), never activated. Every t() call must name
// the page locale explicitly or it renders English - which is why the filter bar stayed English on
// /de while the results grid (which threads its own locale prop) translated correctly.
const LocaleContext = createContext('en')

export function LocaleProvider({ locale = 'en', children = null }) {
  return (
    <LocaleContext.Provider value={locale}>
      {children}
    </LocaleContext.Provider>
  )
}

LocaleProvider.propTypes = {
  locale: string,
  children: node,
}

export const useLocale = () => useContext(LocaleContext)

// Stable per locale, so callers can list it in useMemo/useCallback deps without retriggering.
const useTranslate = () => {
  const locale = useLocale()

  return useMemo(
    () => (key, options) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )
}

export default useTranslate
